<template>
<v-menu v-model="menuWidget" :close-on-content-click="false" :nudge-width="200" offset-x>
    <template v-slot:activator="{ on }">
        <v-btn v-on="on">
            Hiển thị
            <v-icon right dark>arrow_drop_down</v-icon>
        </v-btn>
    </template>
    <v-card>
        <v-list>
            <v-list-item>
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.customer" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Thông tin</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 4">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.product" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Danh sách sản phẩm</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 8">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.transaction" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Mã vận đơn</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 16">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.chat" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Đánh giá đơn hàng</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 32">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.paymentHistory" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Lịch sử thanh toán</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 256">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.paymentArea" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Chi phí đơn hàng</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 32">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.complain" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Lịch sử khiếu nại</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="orderRole & 32">
                <v-list-item-action>
                    <v-switch v-model="orderWidgets.changeHistory" color="#dc3545"></v-switch>
                </v-list-item-action>
                <v-list-item-title>Lịch sử thay đổi</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-card>
</v-menu>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    name: 'order-widget-menu',
    data() {
        return {
            menuWidget: false,
        }
    },
    computed: {
        ...mapState("commons", {
            orderWidgets: "orderWidgets",
        }),
        orderRole() {
            return this.$store.state.authentication.role.Orders;
        }
    },
    watch: {
        orderWidgets: {
            handler: function (newVal) {
                this.$store.dispatch("commons/setOrderWidgets", {widgets: newVal});
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style>

</style>
